import {CHECK_TOKEN} from "@/core/services/store/auth.module";
export default async function isSubscribed ({ to,form,next, store }){
    await store.dispatch(CHECK_TOKEN,to.query.token);
    return next();
}
